import React from 'react';

const CheckoutAgreementsModalContext = React.createContext();

export default CheckoutAgreementsModalContext;
